import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESTARGET,
  DELETE_SALESTARGET,
  UPDATE_SALESTARGET,
  ADD_NEW_SALESTARGET,
} from "./actionType";

import {
  getSalesTargetSuccess,
  getSalesTargetFail,
  deleteSalesTargetSuccess,
  deleteSalesTargetFail,
  updateSalesTargetSuccess,
  updateSalesTargetFail,
  addSalesTargetSuccess,
  addSalesTargetFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesTargetApi,
  getSalesTargetApi,
  updateSalesTargetApi,
  deleteSalesTargetApi,
  addNewSalesTargetApi
} from "../../helpers/backend_helper";

function* getSalesTarget({ payload: salesTarget }) {
  try {
    const response = yield call(getSalesTargetApi, salesTarget);
    yield put(getSalesTargetSuccess(GET_SALESTARGET, response.data));
  } catch (error) {
    yield put(getSalesTargetFail(GET_SALESTARGET, error));
  }
}

function* onUpdateSalesTarget({ payload: salesTarget }) {
  try {
    if (salesTarget.setApprove) {
      const response = yield call(approveSalesTargetApi, salesTarget);
      yield put(updateSalesTargetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesTargetApi, salesTarget);
      yield put(updateSalesTargetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesTargetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesTarget({ payload: salesTarget }) {
  try {
    const response = yield call(deleteSalesTargetApi, salesTarget);
    yield put(deleteSalesTargetSuccess({ salesTarget, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesTargetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesTarget({ payload: salesTarget }) {
  try {
    const response = yield call(addNewSalesTargetApi, salesTarget);
    yield put(addSalesTargetSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesTargetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesTarget() {
  yield takeEvery(GET_SALESTARGET, getSalesTarget);
}

export function* watchUpdateSalesTarget() {
  yield takeEvery(UPDATE_SALESTARGET, onUpdateSalesTarget);
}

export function* watchDeleteSalesTarget() {
  yield takeEvery(DELETE_SALESTARGET, onDeleteSalesTarget);
}

export function* watchAddNewSalesTarget() {
  yield takeEvery(ADD_NEW_SALESTARGET, onAddNewSalesTarget);
}

function* salesTargetSaga() {
  yield all([
    fork(watchGetSalesTarget),
    fork(watchDeleteSalesTarget),
    fork(watchUpdateSalesTarget),
    fork(watchAddNewSalesTarget)
  ]);
}

export default salesTargetSaga;
